/**
 * @file LanguageSelection.jsx
 * @author Rishikesh
 * @date 2024-09-09
 * @description Component of master settings to manage the tab sections.
 */
import React from "react";
import { Box, Skeleton, Tab } from "@mui/material";

import { TabList } from "./Tabs";
import { LanguageSelection } from "./LanguageSelection";
import { DocumentSelection } from "./DocumentSelection";
import { InstallmentSelection } from "./InstallmentSelection";

export const TabPanel = ({
  isLoading,
  value,
  handleChange,
  languages,
  newLanguage,
  setNewLanguages,
  selectedCourse,
  selectedCountry,

  documents,
  newDocuments,
  setNewDocuments,

  installments,
  setInstallments,
  lifecycleEvents,
}) => {
  return (
    <Box
      flex={1}
      borderRadius="12px"
      pb={3}
      bgcolor="#F7F7F7"
      display="flex"
      flexDirection="column"
    >
      {isLoading ? (
        <Skeleton variant="rounded" sx={{ mt: 1 }} width={480} height={36} />
      ) : (
        <TabList value={value} onChange={handleChange}>
          <Tab
            sx={{
              fontSize: 12,
            }}
            label="Language"
            value={0}
          />
          <Tab
            sx={{
              fontSize: 12,
            }}
            label="Documents-Set 1"
            value={1}
          />
          <Tab
            sx={{
              fontSize: 12,
            }}
            label="Documents-Set 2"
            value={2}
          />
          <Tab
            sx={{
              fontSize: 12,
            }}
            label="Installments"
            value={3}
          />
        </TabList>
      )}
      <Box
        display="flex"
        flexDirection="column"
        flex={1}
        overflow={{ xs: "unset", sm: "scroll" }}
      >
        {value === 0 ? (
          <LanguageSelection
            isLoading={isLoading}
            languages={languages}
            newLanguage={newLanguage}
            setNewLanguages={setNewLanguages}
          />
        ) : null}
        {value === 1 || value === 2 ? (
          <DocumentSelection
            isLoading={isLoading}
            selectedCourse={selectedCourse}
            selectedCountry={selectedCountry}
            value={value}
            documents={documents}
            newDocument={newDocuments}
            setNewDocument={setNewDocuments}
          />
        ) : null}
        {value === 3 ? (
          <InstallmentSelection
            isLoading={isLoading}
            installments={installments}
            setInstallments={setInstallments}
            lifecycleEvents={lifecycleEvents}
            selectedCourse={!selectedCourse.id ? "" : selectedCourse.id}
            selectedCountry={selectedCountry}
          />
        ) : null}
      </Box>
    </Box>
  );
};
